import { arrayHasItems } from "../../../helpers/common"
import { formatPurchasePlanningCashRequired } from "../../../lib/purchasePlanningHelpers"

export const TotalsCashLiabilities = ({
    totals
}) => {
    return (
        <div className="mt-4 grid gap-2 md:grid-cols-2 xl:grid-cols-6">
            {arrayHasItems(totals) && (
                totals.map((total) => {
                    return (
                        <div className="rounded-md border border-border bg-background px-3 py-2" key={total.label}>
                            <p className="text-[11px] uppercase tracking-[0.12em] text-gray-600">
                                {total.label ?? ''}
                            </p>
                            {(total.supplierName || total.vendor) && (
                                <p className="mt-1 truncate text-sm font-semibold text-primary whitespace-break-spaces">
                                    {total.supplierName || total.vendor}
                                </p>
                            )}
                            <p className="mt-1 text-lg font-semibold text-primary">
                                {formatPurchasePlanningCashRequired(total.value ?? 0)}
                            </p>
                        </div>
                    )
                })
            )}
        </div>
    )
}